import PropTypes from 'prop-types'
import { Button, Grid, Popover } from '@mui/material'
import { ArrowDropDown } from '@mui/icons-material'
import React, { useState } from 'react'
import { ActionButton } from '../action-buttons'
import { useStyles } from './style'

/**
 * Button with popover and optional apply button. Pass components as children
 * to add contents to the popover.
 */
const Filter = props => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const classes = useStyles({ ...props, open })

  const {
    label,
    children,
    onApply,
    disabled,
    disableApply,
    closeOnClick = false
  } = props

  const id = open ? 'filter' : undefined

  const handleButtonClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
    // onClose()
  }

  const handleApply = () => {
    handleClose()
    onApply()
  }

  return (
    <>
      <Button
        aria-describedby={id}
        data-test={`filter-button-${label?.toLowerCase()}`}
        variant='outlined'
        disabled={disabled}
        classes={{ root: classes.root, label: classes.label }}
        endIcon={<ArrowDropDown />}
        onClick={handleButtonClick}
      >
        {label}
      </Button>
      <Popover
        id={id}
        data-test={`filter-popover-${label?.toLowerCase()}`}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        onClick={() => closeOnClick && handleClose()}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        getContentAnchorEl={null}
        classes={{ paper: classes.popover }}
      >
        {children}
        {!closeOnClick && (
          <Grid container justifyContent='center' className={classes.fixed}>
            <ActionButton
              variant='primary'
              label='Apply'
              disabled={disabled || disableApply}
              onClick={handleApply}
              className={classes.apply}
            />
          </Grid>
        )}
      </Popover>
    </>
  )
}

export default Filter

Filter.propTypes = {
  /**
   * Contents of the filter button
   */
  label: PropTypes.string.isRequired,
  /**
   * Contents of the popover e.g a menu
   */
  children: PropTypes.any,
  /**
   *  Displays an apply button. Will close the popover
   */
  onApply: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  /**
   *  Disables the button and popover
   */
  disabled: PropTypes.bool,
  /**
   *  Should the popover close when it is clicked?
   * (e.g for single selection menu)
   */
  closeOnClick: PropTypes.bool
}

Filter.defaultProps = {
  onApply: undefined,
  disabled: false,
  closeOnClick: false
}
